import {GlobalActionTypes} from './types';
import {AppStore} from "../../desktop";
import {AppCookies} from "../../core/Cookies";
import {User} from "../../models/User";
import {toastr} from "react-redux-toastr";

export const actionStartGlobalLoading = () => {AppStore.dispatch({type: GlobalActionTypes.START_LOADING})}
export const actionEndGlobalLoading = () => {AppStore.dispatch({type: GlobalActionTypes.END_LOADING})}
export const actionShrinkMainMenu = () => {AppStore.dispatch({type: GlobalActionTypes.SHRINK_MAIN_MENU})}
export const actionExtendMainMenu = () => {AppStore.dispatch({type: GlobalActionTypes.EXTEND_MAIN_MENU})}

export const actionUserLogin = (username: string, password: string) => {
	AppStore.dispatch({type: GlobalActionTypes.LOGIN_REQUEST, payload: {username: username, password: password}})
}

export const actionUserLoginCompleted = (data: any, status: string) => {
	let accessToken = data ? data.token : ''
	let loginError: boolean = accessToken ? false : true
	if (accessToken) AppCookies.setAccessToken(accessToken)
	AppStore.dispatch({type: GlobalActionTypes.LOGIN_COMPLETED, payload: {accessToken: accessToken, loginError: loginError}})
}

export const actionUserSetAccessToken = (accessToken: string) => {
	AppStore.dispatch({type: GlobalActionTypes.SET_ACCESS_TOKEN, payload: accessToken})
}

export const actionUserLogout = () => {
	AppCookies.setAccessToken('')
	// todo: call api to revoke token
	AppStore.dispatch({type: GlobalActionTypes.SET_ACCESS_TOKEN, payload: null})
	AppStore.dispatch({type: 'RESET_APP', payload: null})
}

export const actionCurrentUserFetch = () => {
	AppStore.dispatch({type: GlobalActionTypes.CURRENT_USER_REQUEST, payload: null})
}

export const actionCurrentUserCompleted = (user: User) => {
	AppStore.dispatch({type: GlobalActionTypes.CURRENT_USER_COMPLETED, payload: user})
}

export const actionToastrWarning = (title: string, message: string) => {
	toastr.warning(title, message)
}

export const actionToastrInfo = (title: string, message: string) => {
	toastr.info(title, message)
}

export const actionUserForgotPasswordRequest = (username: string) => {
	AppStore.dispatch({type: GlobalActionTypes.FORGOT_PASSWORD_REQUEST, payload: {username: username, error: false, completed: false}});
}

export const actionUserForgotPasswordCompleted = (error: boolean) => {
	AppStore.dispatch({type: GlobalActionTypes.FORGOT_PASSWORD_COMPLETED, payload: {error: error, completed: true}});
}

export const actionUserForgotPasswordRequestReset = () => {
	AppStore.dispatch({type: GlobalActionTypes.FORGOT_PASSWORD_REQUEST_RESET, payload: {error: false, completed: false}});
}

export const actionUserFetchByResetPasswordToken = (token: string) => {
	AppStore.dispatch({type: GlobalActionTypes.FETCH_BY_RESET_PASSWORD_TOKEN, payload: token});
}

export const actionUserFetchByResetPasswordTokenCompleted = (user: User, error: boolean) => {
	AppStore.dispatch({type: GlobalActionTypes.FETCH_BY_RESET_PASSWORD_TOKEN_COMPLETED, payload: {user: user, error: error}});
}

export const actionUserResetPasswordRequest = (userId: string, password: string) => {
	AppStore.dispatch({type: GlobalActionTypes.RESET_PASSWORD_REQUEST,  payload: {userId: userId, password: password}});
}

export const actionUserResetPasswordCompleted = (error: boolean) => {
	AppStore.dispatch({type: GlobalActionTypes.RESET_PASSWORD_COMPLETED, payload: {error: error, completed: true}});
}

export const actionUserResetPasswordRequestReset = () => {
	AppStore.dispatch({type: GlobalActionTypes.RESET_PASSWORD_REQUEST_RESET, payload: {error: false, completed: false}});
}
